jQuery(function($) {

	var redirect_us = $.cookie('redirect_us');

    var url = window.top.location.href,
      status = url.split('?')[1];

      console.log(status);
      
  	if ( status == 'no-redirect' ) {
  	  $.cookie('redirect_us', 'no', {
  	        expires: 7 // the number of days cookie  will be effective
  	  });
  	}	
  	if ( status != undefined ) {     
  	  var country = status.split('_')[1];
      
  	  if (country == 'ca') { 
  	    $('.store-link').attr('href','https://lalo.ca/?no-redirect');
  	    $('.store-link').text('Take me to LALO.CA');  
  	  }
      else if (country == 'gb') { 
        $('.store-link').attr('href','https://lalo-uk.myshopify.com/?no-redirect');
        $('.store-link').text('Take me to lalo-uk.myshopify.com');  
      }
      else if (country == 'il') { 
        $('.store-link').attr('href','https://lalo-israel.myshopify.com/?no-redirect');
        $('.store-link').text('Take me to lalo-israel.myshopify.com');  
      }
      else if (country == 'au') { 
        $('.store-link').attr('href','https://lalo-australia.myshopify.com/?no-redirect');
        $('.store-link').text('Take me to lalo-australia.myshopify.com');  
      }
      else if (country == 'eu') { 
        $('.store-link').attr('href','https://lalo-europe.myshopify.com/?no-redirect');
        $('.store-link').text('Take me to lalo-europe.myshopify.com');  
      }
  	}
    
    if ( status == 'redirectedFrom_ca' || status == 'redirectedFrom_gb' || status == 'redirectedFrom_il' || status == 'redirectedFrom_au' || status == 'redirectedFrom_eu' ) {
      setTimeout(function () {
        $('#redirect-bar').slideDown('slow');  
      }, 1000);
    }     
    else if (redirect_us == 'no') {
        return false;
    }      
    

    // onclick close redirect bar
    $('.redirect-btn.no').click(function(e) {
      e.preventDefault();
      $('#redirect-bar').slideUp('slow');

      $.cookie('redirect_us', 'no', {
            expires: 7 // the number of days cookie  will be effective
      });
    });

  // redirect 
  jQuery.ajax( {
    url: '//freegeoip.io/json/',
    type: 'POST',
    dataType: 'jsonp',
    success: function(location) {
      $('#redirect-bar .redirect-bar-text .country').text(location.country_name);

      var url = window.location.href,
          status = url.split('?')[1];
      
      if (location.country_code === 'CA'){
         window.top.location.href = 'https://lalo.ca/?redirectedFrom_us';     
      } 
      /*
      else if (location.country_code === 'GB'){
         window.top.location.href = 'https://lalo-uk.myshopify.com/?redirectedFrom_us';     
      } 
      else if (location.country_code === 'IL'){
         window.top.location.href = 'https://lalo-israel.myshopify.com/?redirectedFrom_us';     
      } 
      else if (location.country_code === 'AU'){
         window.top.location.href = 'https://lalo-australia.myshopify.com/?redirectedFrom_us';     
      } 
      // countries in EU except GB
      else if (location.country_code === 'AD' || location.country_code === 'AL' || location.country_code === 'AT' || location.country_code === 'AX' || location.country_code === 'BA' || location.country_code === 'BF' || location.country_code === 'BG' || location.country_code === 'BY' || location.country_code === 'CH' || location.country_code === 'CS' || location.country_code === 'CY' || location.country_code === 'CZ' || location.country_code === 'DE' || location.country_code === 'DK' || location.country_code === 'EE' || location.country_code === 'ES' || location.country_code === 'FI' || location.country_code === 'FO' || location.country_code === 'FR' || location.country_code === 'GG' || location.country_code === 'GI' || location.country_code === 'GR' || location.country_code === 'HR' || location.country_code === 'HU' || location.country_code === 'IE' || location.country_code === 'IM' || location.country_code === 'IS' || location.country_code === 'IT' || location.country_code === 'JE' || location.country_code === 'LI' || location.country_code === 'LT' || location.country_code === 'LU' || location.country_code === 'LV' || location.country_code === 'MC' || location.country_code === 'MD' || location.country_code === 'ME' || location.country_code === 'MK' || location.country_code === 'MT' || location.country_code === 'NL' || location.country_code === 'NO' || location.country_code === 'PL' || location.country_code === 'PT' || location.country_code === 'RO' || location.country_code === 'RS' || location.country_code === 'RU' || location.country_code === 'SE' || location.country_code === 'SI' || location.country_code === 'SJ' || location.country_code === 'SK' || location.country_code === 'SM' || location.country_code === 'UA' || location.country_code === 'VA' || location.country_code === 'XK'){
        window.top.location.href = 'https://lalo.eu//?redirectedFrom_us';      
      } 
      */
    }
  });

});